﻿import $ from "jquery";
import ajax from "./ajax";
import { addCallback as addTableCallback } from "./td-table.js";

addTableCallback(function initKanbanMenu(ctx) {
	$(".td-kanbancellmenu>a", ctx).each(function() {
		var e = $(this);
		var menu = e.next(".ui-menu");
		menu.menu().popup(e, { my: "right top", at: "right bottom" });
	});
});

addTableCallback(function initDragAndDrop(ctx) {
	$(".td-calendar.td-draggable,.td-kanbanviewlane.td-draggable", ctx).each(function() {
		var e = $(this);
		var id = e.attr("id");
		var t = e.is("table") ? e : e.closest("table");
		var vid = t.attr("data-viewid");
		var fid = t.attr("data-fid");
		$(".td-draglist", e).sortable({
			cursor: "move",
			items: ".td-draggable",
			connectWith: "#" + id + " .td-droppable",
			start: function (/*e, ui*/) {
				// console.log("Start dragging");
			},
			stop: function(e, ui) {
				var from = ui.item.parent().attr("data-basevalue");
				var to = $(this).attr("data-basevalue");
				// TODO -- cancel drop to the same status
				if(from == to)
					$(this).sortable("cancel");
			},
			receive: function(e, ui) {
				var anchor = ui.item.attr("id");
				function reload() {
					var url = location.href;
					var hash = url.indexOf("#");
					if(hash >= 0)
						url = url.substring(0, hash);
					if(anchor)
						url += "#" + anchor;
					location.href = url;
					location.reload();
				}
				var id = ui.item.attr("data-rowid");
				var to = $(this).attr("data-basevalue");
				var data = {};
				data["f_" + fid] = to;
				ajax({
					url: "js.aspx?cmd=rowsave&v=" + encodeURIComponent(vid) + "&id=" + encodeURIComponent(id),
					method: "POST",
					data: data,
					dataType: "json",
					success: function(data/*, status, xhr*/) {
						if(data.controldata && data.controldata.invalid) {
							var i = data.controldata.invalid, err = [];
							if(i.common) Array.prototype.push.apply(err, i.common);
							for(var k in i) {
								if(k != "common")
									err.push(i[k]);
							}
							// console.log("Kanban item #" + id + " was not changed: ", err);
							alert("There are errors:\r\n\r\n* " + err.join("\r\n* "));
						} else {
							// console.log("Kanban item #" + id + " status changed to", to);
						}
					},
					error: function(_xhr, status, error) {
						var msg = error || status;
						alert(msg);
						console.error("Kanban item #" + id + " status change error:", msg);
					},
					complete: reload
				});
			}
		});
	});
});
